import React from "react"
import { MyPageHelpers } from "@macashipo/mlib"

const MUI_simulator_sender_email = React.lazy(() =>
  import("./Types/simulator_sender_email")
)
const MUI_admin_homeclient = React.lazy(() =>
  import("./Types/admin_homeclient")
)

const List = {
  simulator_sender_email: MUI_simulator_sender_email,
  admin_homeclient: MUI_admin_homeclient,
}
const MyPageOne = {
  init() {
    MyPageHelpers.addTypesFromListLazy(List)
  },
}

export default MyPageOne
